import { ReactComponent as LoadingIconSVG } from '@/assets/icons/LoadingIcon.svg';
import { SVGProps } from 'react';

const LoadingIcon = (props: SVGProps<SVGSVGElement>) => <LoadingIconSVG {...props} />;

export default LoadingIcon;
